import localeMessageBox from '@/components/message-box/locale/en-US';
import localeLogin from '@/views/login/locale/en-US';

import localeWorkplace from '@/views/dashboard/workplace/locale/en-US';
import localeDashboardOverview from '@/views/dashboard/overview/locale/en-US';
import localeDashboardPayment from '@/views/dashboard/payment/locale/en-US';
/** simple */
import localeMonitor from '@/views/dashboard/monitor/locale/en-US';

import localeSearchTable from '@/views/list/search-table/locale/en-US';
import localeCardList from '@/views/list/card/locale/en-US';

import localeStepForm from '@/views/form/step/locale/en-US';
import localeGroupForm from '@/views/form/group/locale/en-US';

import localeBasicProfile from '@/views/profile/basic/locale/en-US';

import localeDataAnalysis from '@/views/visualization/data-analysis/locale/en-US';
import localeMultiDAnalysis from '@/views/visualization/multi-dimension-data-analysis/locale/en-US';

import localeSuccess from '@/views/result/success/locale/en-US';
import localeError from '@/views/result/error/locale/en-US';

import locale403 from '@/views/exception/403/locale/en-US';
import locale404 from '@/views/exception/404/locale/en-US';
import locale500 from '@/views/exception/500/locale/en-US';

import localeUserInfo from '@/views/user/info/locale/en-US';
import localeUserSetting from '@/views/user/setting/locale/en-US';
import localeUserManagement from '@/views/user/management/locale/en-US';

import localeStoreManagement from '@/views/store/management/locale/en-US';
import localeBackupStoreManagement from '@/views/store/backup/locale/en-US';
import localeArchiveStoreManagement from '@/views/store/archive/locale/en-US';
import localePaymentList from '@/views/payment/list/locale/en-US';
import localeStoreConfig from '@/views/payment/store-config/locale/en-US';
import localePaymentGateway from '@/views/payment/gateway/locale/en-US';
import localeOrderList from '@/views/order/list/locale/en-US';
import localeSubscriptionOrderList from '@/views/order/subscription-order-list/locale/en-US';
import localeSubscriptionList from '@/views/order/subscription/locale/en-US';
import localeEmailLog from '@/views/order/email-log/locale/en-US';
import localeExportRecords from '@/views/order/export-records/locale/en-US';
import localeEmailTemplate from '@/views/order/email-template/locale/en-US';
import localeMerchantManagement from '@/views/merchant/management/locale/en-US';
/** simple end */
import localeSettings from './en-US/settings';

export default {
  'menu.dashboard': 'Overview',
  'menu.dashboard.overview': 'Overview',
  'menu.dashboard.orders': 'Orders dashboard',
  'menu.dashboard.subscriptions': 'Subscriptions dashboard',
  'menu.dashboard.payment': 'Payment dashboard',
  'menu.server.dashboard': 'Overview-Server',
  'menu.server.workplace': 'Workplace-Server',
  'menu.server.monitor': 'Monitor-Server',
  'menu.list': 'List',
  'menu.result': 'Result',
  'menu.exception': 'Exception',
  'menu.form': 'Form',
  'menu.profile': 'Profile',
  'menu.visualization': 'Data Visualization',
  'menu.user': 'User Management',
  'menu.user.management': 'User Management',
  'menu.store': 'Store Management',
  'menu.store.management': 'Store Management',
  'menu.store.backup': 'Backup Store',
  'menu.store.archive': 'Archived Stores',
  'menu.payment': 'Payment Management',
  'menu.payment.list': 'Payment List',
  'menu.payment.storeConfig': 'Store Configuration',
  'menu.payment.gateway': 'Payment Gateway',
  'menu.order': 'Order Management',
  'menu.order.list': 'Order List',
  'menu.order.subscriptionOrderList': 'Subscription Order List',
  'menu.order.emailTemplate': 'Email Templates',
  'menu.subscription': 'Subscription Management',
  'menu.subscription.list': 'Subscription Records',
  'menu.subscription.emailLog': 'Email Logs',
  'menu.exportRecords': 'Export Records',
  // Keep legacy menu keys for compatibility
  'menu.order.subscription': 'Subscription Records',
  'menu.order.exportRecords': 'Export Records',
  'menu.merchant': 'Merchant Management',
  'menu.merchant.management': 'Merchant Management',
  'menu.profileCenter': 'Profile Center',
  'menu.profileCenter.myInfo': 'My Information',
  'menu.arcoWebsite': 'Arco Design',
  'menu.faq': 'FAQ',
  'footer.copyright': 'Ouyi 2026 © All rights reserved.',
  'navbar.docs': 'Docs',
  'navbar.action.locale': 'Switch to English',
  'navbar.title': 'Ouyi Store Admin',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,
  ...localeDashboardOverview,
  ...localeDashboardPayment,
  /** simple */
  ...localeMonitor,
  ...localeSearchTable,
  ...localeCardList,
  ...localeStepForm,
  ...localeGroupForm,
  ...localeBasicProfile,
  ...localeDataAnalysis,
  ...localeMultiDAnalysis,
  ...localeSuccess,
  ...localeError,
  ...locale403,
  ...locale404,
  ...locale500,
  ...localeUserInfo,
  ...localeUserSetting,
  ...localeUserManagement,
  ...localeStoreManagement,
  ...localeBackupStoreManagement,
  ...localeArchiveStoreManagement,
  ...localePaymentList,
  ...localeStoreConfig,
  ...localePaymentGateway,
  ...localeOrderList,
  ...localeSubscriptionOrderList,
  ...localeSubscriptionList,
  ...localeEmailLog,
  ...localeExportRecords,
  ...localeEmailTemplate,
  ...localeMerchantManagement,
  'storeManagement.columns.email': 'Email Configuration',
  /** simple end */
};
